import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import SidebarMenu from "../../../Components/SidebarMenu";
import api from "../../../Services/api";
import { Page } from "../../SignedOut/Cadastro/styles";
import { PageTitle } from "../CadastrarMedico/styles";
import { PacientInfo, PacientRow, InfoBlock, InfoTitle, Info } from "./styles";
import ReactLoading from "react-loading";
import Affiliates from "../../../Components/Afilliate";
import { AceitarButton, RecusarButton } from "../Pendentes/styled";
import { toast } from "react-toastify";
import { useHistory } from "react-router";
import PageContainer from "../../../Components/PageContainer";
import { Background, PageContainerDiv, RightDiv } from "../Perfil/styles";

export default function PacienteUnico() {
  const { id } = useParams();
  const [paciente, setPaciente] = useState([]);
  const [loading, setLoading] = useState(true);
  const [requestDone, setRequestDone] = useState(false);
  const [loadingStatus, setLoadingStatus] = useState(false);
  const history = useHistory();

  async function handleStatusChange(id, novoStatus) {
    setLoadingStatus(true);
    try {
      const trocaStatus = await api.patch(`/usuario/alterar_status/${id}`, { ST_usuario: novoStatus });
      console.log(handleStatusChange);
      const showToastMessage = () => {
        toast.success(`Status do paciente alterado`, {
          position: toast.POSITION.TOP_CENTER,
        });
      };
      showToastMessage();
      history.push("/pacientes");
    } catch (error) {
      const showToastMessageError = () => {
        toast.error(`Não foi possível alterar o status do paciente`, {
          position: toast.POSITION.TOP_CENTER,
        });
      };
      showToastMessageError();
      console.log(error);
    }
    finally {
      setLoadingStatus(false);
    }
  }

  const fetchRepositoriesData = async () => {
    setLoading(true);
    try {
      const response = await api.get(`/usuario/por_id/${id}`);
      setPaciente(response.data);
      console.log("paciente", response.data);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
      setRequestDone(true);
    }
  };

  useEffect(() => {
    fetchRepositoriesData();
  }, [id]);

  if (loading || !requestDone) {
    return (
      <Page>
        <SidebarMenu />
        <PageContainerDiv>
          <SidebarMenu />
          <Background>
            <RightDiv>
              <PageTitle>Paciente</PageTitle>
              <ReactLoading
                type="spin"
                color="#B2EBF2"
                height={"30px"}
                width={"30px"}
              />
            </RightDiv>
          </Background>
        </PageContainerDiv>
      </Page>
    );
  }

  return (
    <Page>
      <SidebarMenu />

      <PageContainerDiv>
        <SidebarMenu />
        <Background>
          <RightDiv>
            <PageTitle>Paciente</PageTitle>
            <PacientInfo>
              <PacientRow>
                <InfoBlock>
                  <InfoTitle>Nome:</InfoTitle>
                  <Info>{paciente?.NO_primeiro_nome + " " + paciente?.NO_ultimo_nome}</Info>
                </InfoBlock>
                <InfoBlock>
                  <InfoTitle>CPF:</InfoTitle>
                  <Info>{paciente?.NU_cpf}</Info>
                </InfoBlock>
              </PacientRow>
              <PacientRow>
                <InfoBlock>
                  <InfoTitle>Email:</InfoTitle>
                  <Info>{paciente?.DS_email}</Info>
                </InfoBlock>
                <InfoBlock>
                  <InfoTitle>Telefone:</InfoTitle>
                  <Info>{paciente?.NU_telefone}</Info>
                </InfoBlock>
              </PacientRow>
              <PacientRow>
                {paciente?.paciente &&
                <InfoBlock>
                  <InfoTitle>Afiliados:</InfoTitle>
                  <Info>
                    {paciente?.afiliados?.length === 0 || !requestDone
                      ? "Não há pacientes afiliados."
                      : paciente?.afiliados.map((item, index) => (
                          <div key={index}>
                            <Affiliates afiliado={item} />
                          </div>
                        ))}
                  </Info>
                </InfoBlock>}
                {paciente?.paciente 
                ?
                <InfoBlock>
                  <InfoTitle>Créditos:</InfoTitle>
                  <Info>{paciente?.paciente?.NU_creditos} crédito(s)</Info>
                </InfoBlock>
                :
                <InfoBlock>
                  <InfoTitle>Créditos gastos:</InfoTitle>
                  <Info>{paciente?.afiliado.QT_gasta_mes ? paciente?.afiliado.QT_gasta_mes : 0} crédito(s)</Info>
                </InfoBlock>
                }
              </PacientRow>
              <PacientRow>
                <InfoBlock>
                    <InfoTitle>Status do usuário:</InfoTitle>
                    <Info>{paciente?.ST_usuario}</Info>
                  </InfoBlock>
                {paciente?.ST_usuario === "ATIVO" 
                  ?
                  <InfoBlock>
                    <InfoTitle>Bloquear usuário:</InfoTitle>
                    <RecusarButton
                      onClick={() => handleStatusChange(paciente.id_usuario, "SUSPENSO")} disabled={loadingStatus}
                    >
                      {
                      loadingStatus ?
                      <ReactLoading
                        type="spin"
                        color="#ffffff"
                        height={"30px"}
                        width={"30px"}
                        className="m-auto"
                      />
                      :
                      "Bloquear"
                      }
                    </RecusarButton>
                  </InfoBlock>
                  :
                  <InfoBlock>
                    <InfoTitle>Desbloquear usuário:</InfoTitle>
                    <AceitarButton
                      onClick={() => handleStatusChange(paciente.id_usuario, "ATIVO")} disabled={loadingStatus}
                    >
                      {
                      loadingStatus ?
                      <ReactLoading
                        type="spin"
                        color="#ffffff"
                        height={"30px"}
                        width={"30px"}
                        className="m-auto"
                      />
                      :
                      "Desbloquear"
                      }
                    </AceitarButton>
                  </InfoBlock>
                }
              </PacientRow>
            </PacientInfo>
          </RightDiv>
        </Background>
      </PageContainerDiv>
    </Page>
  );
}
